import script from "./MainLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainLoader.vue?vue&type=script&setup=true&lang=ts"

import "./MainLoader.vue?vue&type=style&index=0&id=247d14fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-247d14fe"]])

export default __exports__